import { FC, useEffect, useState } from 'react'

interface IMarkWrapper {
  children: JSX.Element
  geometry: [number, number] | null
}

// wrapper для меток
// нужен для того чтобы метка не рендерилась до рендера самой карты
export const PlacemarkWrapper: FC<IMarkWrapper> = ({ children, geometry }) => {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsReady(true), 0)
    return () => clearTimeout(timer)
  }, [])

  if (isReady && geometry && geometry[0] && geometry[1] && !!window.map)
    return <>{children}</>
  return <></>
}
